import React, { createContext, useCallback, useState } from "react";
import { useRouter } from "next/router";
import { noop } from "@catchoftheday/utilities";
import { removeMultipleQueryStringKeys, removeQueryStringKey, removeQueryStringValue, updateMultipleQueryStringValues, updateQueryStringValue } from "../utilities/api";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CatalogueContext = /*#__PURE__*/createContext({
  addFilterValue: noop,
  addMultipleFilterValues: noop,
  removeFilterValue: noop,
  removeFilterKey: noop,
  removeAllFilters: noop,
  searchResponse: null,
  updateSearchResponse: noop,
  isSearchLoading: false,
  updateSearchLoading: noop
});
export var CatalogueContextProvider = function CatalogueContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      searchResponse = _useState[0],
      setSearchResponse = _useState[1];

  var _useState2 = useState(false),
      isSearchLoading = _useState2[0],
      setIsSearchLoading = _useState2[1];

  var router = useRouter();
  var addFilterValue = useCallback(function (key, value, allowMultiple) {
    updateQueryStringValue(router, key, value, allowMultiple);
  }, [router]);
  var addMultipleFilterValues = useCallback(function (params) {
    updateMultipleQueryStringValues(router, params);
  }, [router]);
  var removeFilterValue = useCallback(function (key, value) {
    removeQueryStringValue(router, key, value);
  }, [router]);
  var removeFilterKey = useCallback(function (key) {
    removeQueryStringKey(router, key);
  }, [router]);
  var removeAllFilters = useCallback(function () {
    removeMultipleQueryStringKeys(router, "f.");
  }, [router]);
  var updateSearchResponse = useCallback(function (response) {
    setSearchResponse(response);
  }, []);
  var updateSearchLoading = useCallback(function (loading) {
    setIsSearchLoading(loading);
  }, []);
  return ___EmotionJSX(CatalogueContext.Provider, {
    value: {
      addFilterValue: addFilterValue,
      addMultipleFilterValues: addMultipleFilterValues,
      removeFilterValue: removeFilterValue,
      removeFilterKey: removeFilterKey,
      removeAllFilters: removeAllFilters,
      searchResponse: searchResponse,
      updateSearchResponse: updateSearchResponse,
      isSearchLoading: isSearchLoading,
      updateSearchLoading: updateSearchLoading
    }
  }, children);
};